import { Box, Stack } from '@mui/material';
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Folder as FolderIcon, Business as BusinessIcon } from '@mui/icons-material';

export const FascicoliListView = ({ fascicoli }) => {    
    if (!fascicoli || fascicoli.length === 0) {
        return (
            <Box sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    Nessun fascicolo associato
                </Typography>
            </Box>
        );
    }

    return (
        <Box 
            sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
            }}
        >
            <Typography 
                variant="subtitle2" 
                sx={{ 
                    mb: 1.5,
                    fontWeight: 'bold',
                    color: 'primary.main',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }}
            >
                <FolderIcon fontSize="small" />
                Fascicoli Associati ({fascicoli.length})
            </Typography>
            
            <Box
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    pr: 1,
                    '&::-webkit-scrollbar': {
                        width: '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                        borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#888',
                        borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#555',
                    },
                }}
            >
                <Stack direction="column" spacing={1.5}>
                    {fascicoli.map((fascicolo, index) => (
                        <Box 
                            key={fascicolo.id || index}
                            sx={{ 
                                p: 1.5,
                                border: '1px solid #e0e0e0',
                                borderRadius: 1,
                                backgroundColor: '#fafafa',
                                '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                    borderColor: '#bdbdbd',
                                }
                            }}
                        >
                            <Stack direction="column" spacing={0.75}>
                                {/* Nome Fascicolo */}
                                <Typography 
                                    variant="body2" 
                                    sx={{ 
                                        fontWeight: 'bold',
                                        color: 'text.primary',
                                        fontSize: '0.875rem'
                                    }}
                                >
                                    {fascicolo.nomeFascicolo}
                                </Typography>
                                
                                {/* Azienda */}
                                <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="space-between">
                                    <Stack direction="row" spacing={0.5} alignItems="center">
                                        <BusinessIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                                        <Typography 
                                            variant="caption" 
                                            color="text.secondary"
                                            sx={{ fontSize: '0.75rem' }}
                                        >
                                            {fascicolo.nomeAzienda}
                                        </Typography>
                                    </Stack>                                                                        
                                </Stack>                                                            
                            </Stack>
                        </Box>
                    ))}
                </Stack>
            </Box>
        </Box>
    );
};
